const patternNumber = /^\d{1,10}$/;
const patternPurse = /^\d{12,15}$/;

export default {
  data() {
    return {
      current: {},
      enabledPaymentsMethods: [],
      settings: [],
      paymentFinish: false,
      isLoad: false,
      isCalculate: false,
      commission: '',
      timeout: null,
      form: {
        value: '',
        amount: '',
        valid: true,
        additional_agreement: false,
      },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        phoneLength: value => (value && value.length >= 17) || 'Номер телефона заполнен не полностью',
        cardLength: value => (value && value.length >= 19) || 'Номер карты заполнен не полностью',
        summLength: value => (value && +value >= 1500) || 'Сумма должна быть больше 1500р',
        number: value => patternNumber.test(value) || 'Поле должно содержать только числа',
        purse: value => patternPurse.test(value) || 'Поле должно содержать только числа',
      },
    };
  },
  watch: {
    // eslint-disable-next-line
    'current.type': function (_) {
      this.calculateBonuses();
    },
    // eslint-disable-next-line
    'form.amount': function (_) {
      this.calculateBonuses();
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isBlockedPrizes() {
      return this.user && !!this.user.blocked_prizes_at;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    paymentsInfo() {
      const { paymentsInfo } = this.$store.state;
      return paymentsInfo;
    },
    hasTaxes() {
      return this.$store.state.settings.taxes === true;
    },
    userHasPassport() {
      return this.user && this.user.account && this.user.account.status === 'approved';
    },
    userCanMakeTransaction() {
      return this.user && this.user.can_make_transaction;
    },
    userCanMakeTransactionReason() {
      return this.user && this.user.can_make_transaction_reason;
    },
  },
  methods: {
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    },
    calculateBonuses() {
      const app = this;
      const { type } = app.current;
      const { amount } = app.form;
      app.commission = null;

      this.clearTimeout();
      if (!amount || !type) {
        return;
      }
      app.timeout = setTimeout(() => {
        app.$store.getters.axl.post('payments/api-v3/payments/calculate', { type, amount })
          .then((response) => {
            // eslint-disable-next-line no-unused-vars
            const { totalAmount, message } = response.data;
            if (amount === totalAmount) {
              this.commission = null;
            } else {
              this.commission = `Спишется ${totalAmount} баллов`;
            }
          })
        // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            this.commission = null;
          });
      }, 720);
    },
    GetPaymentsSettings() {
      const app = this;
      app.$store.getters.axl.post('api/login', { login: app.login, password: app.password })
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    handleChangeMethod(item) {
      this.current = item;
      this.ResetForm();
    },
    paymentSubmit() {
      const app = this;
      if (app.form.valid) {
        app.isLoad = true;
        const payment = {
          profile_id: app.user.profile_id,
          type: app.current.type,
          amount: app.form.amount,
          additional_agreement: app.form.additional_agreement,
          parameters: {
            phone_mobile: app.form.value,
          },
        };
        app.$store.getters.axl.post('payments/api-v4/payments/create', payment)
          .then(() => {
            app.ResetForm();
            this.$store.dispatch('GetProfile');
            app.paymentFinish = true;
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          })
          .finally(() => {
            app.isLoad = false;
          });
      }
    },
    ResetForm() {
      this.$refs.form.reset();
      this.form.amount = '';
      this.form.value = '';
    },
  },
  async mounted() {
    await this.$store.dispatch('GetPaymentsSettings')
      .then((data) => {
        if (data && data.settings && data.settings.length) {
          const enabledPaymentsMethods = data.settings.filter(method => method.enabled);
          this.enabledPaymentsMethods = enabledPaymentsMethods;
          this.current = enabledPaymentsMethods.length ? enabledPaymentsMethods[0] : {};
        }
      });
  },
  beforeDestroy() {
    this.clearTimeout();
  },
};
